import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import FullscreenLoader from "../components/FullscreenLoader";
import Snackbar from "../components/Snackbar";
import createCustomStore from "../store";
import { createBrowserHistory } from "history";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import MobilePage from "./pages/MobilePage";
import Routes from "./Routes";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./pages/ErrorPage";
import { LoadScript } from "@react-google-maps/api";
import { BrowserView, MobileView } from "react-device-detect";

const App = React.memo(() => {
  const [ sagasError, setSagasError ] = React.useState();
  const { history, store, theme } = React.useMemo(() => {
    const browserHistory = createBrowserHistory();
    const { sagas, store } = createCustomStore(browserHistory);
    sagas.catch(setSagasError);
    return ({
      history: browserHistory,
      store,
      theme: createMuiTheme({
        typography: {
          fontFamily: "Ubuntu, sans-serif",
        },
        palette: {
          primary: {
            main: "#223065",
          },
          secondary: {
            main: green[500],
          },
        },
      }),
    });
  }, [ setSagasError ]);

  React.useEffect(() => {
    if (sagasError) {
      throw sagasError;
    }
  }, [ sagasError ]);

  return (
    <ThemeProvider theme={theme}>
      <ReduxProvider store={store}>
        <FullscreenLoader />
        <Snackbar />
        <LoadScript
          libraries={[ "places" ]}
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
          loadingElement={" "}
        >
          <BrowserView>
            <ConnectedRouter history={history}>
              <Routes />
            </ConnectedRouter>
          </BrowserView>
        </LoadScript>
        <MobileView>
          <MobilePage />
        </MobileView>
      </ReduxProvider>
    </ThemeProvider>
  );
});


const AppContainer = React.memo(() =>
  <ErrorBoundary fallbackRender={() => <ErrorPage />}>
    <App />
  </ErrorBoundary>,
);

export default AppContainer;
